import React from 'react';
import './CSS/AnswerTwo.css';
import img1 from "../Images/Gallery/Rectangle 74.png";
import img2 from "../Images/Gallery/Rectangle 3.png";
import img3 from "../Images/Gallery/Rectangle 4.png";
import img4 from "../Images/Gallery/Rectangle 5.png";
import img5 from "../Images/Gallery/Rectangle 6.png";
import { Link } from "react-router-dom";

const events = [
  {
    id: 1,
    image: img2,
    title: "‘गावकुसाबाहेर कविता’",
    place: "प्राचीन वडाचं मंदिर ",
    topic: "गावाचं कवितेत प्रतिबिंब",
    details: "३० कवी,स्थानिक रसिक प्रेक्षक ",
    date: "१४ ऑगस्ट, २०२४",
    link: "/Answer",
  },
  {
    id: 2,
    image: img3,
    title: "‘श्रावण कविता मैफल’",
    place: "जिल्हा परिषद हॉल",
    topic: "पावसाच्या रात्री, मोकळ्या सभागृहात ",
    details: "३० कवी, स्थानिक रसिक प्रेक्षक",
    date: "१३ सप्टेंबर, २०२४",
  },
  {
    id: 3,
    image: img4,
    title: "‘कविता आणि सामाजिक जाणीव’",
    place: "जिल्हा परिषद हॉल",
    topic: "स्त्रीवाद, पर्यावरण, लोकशाही विशेष",
    details: "कविता आणि क्रांती",
    date: "१० आँक्टोंबर, २०२४",
  },
  {
    id: 4,
    image: img5,
    title: "‘कवितेचं महाकुंभ’",
    place: "जिल्हा परिषद हॉल",
    topic: "५० जिल्ह्यांतील १०० कवी",
    details: "कवितांची छायाचित्रे + हस्ताक्षर संग्रह",
    date: "१८ नोव्हेंबर, २०२४",
  },
  {
    id: 5,
    image: img3,
    title: "‘श्रावण कविता मैफल’",
    place: "जिल्हा परिषद हॉल",
    topic: "पावसाच्या रात्री, मोकळ्या सभागृहात ",
    details: "३० कवी, स्थानिक रसिक प्रेक्षक",
    date: "१३ सप्टेंबर, २०२४",
  },
  {
    id: 6,
    image: img4,
    title: "‘कविता आणि सामाजिक जाणीव’",
    place: "जिल्हा परिषद हॉल",
    topic: "स्त्रीवाद, पर्यावरण, लोकशाही विशेष",
    details: "कविता आणि क्रांती",
    date: "१० आँक्टोंबर, २०२४",
  }
];

const AnswerTwo = () => {
  return (
    <div className="answer-two-section">
      <img src={img1} alt="Library" className="answer-two-background-image" />

      <div className="answer-two-overlay-text">
        <h2 className="answer-two-title">
          <span className="answer-two-orange">पुर्व </span>
          <span className="answer-two-white">कार्यक्रम</span>
        </h2>
      </div>

      <div className="answer-two-grid">
        {events.map((event, index) => (
          <div key={index} className="answer-two-card">
            <div className="answer-two-content">
              <img src={event.image} alt={event.title} />
              <h3 className="answer-two-event-title">{event.title}</h3>
              <p className="answer-two-event-place">{event.place}</p>
              <p className="answer-two-event-topic">{event.topic}</p>
              <p className="answer-two-event-details">{event.details}</p>
              <span className="answer-two-event-date">{event.date}</span>
              <div className="answer-two-footer">
                {event.link ? (
                  <Link to={event.link} className="answer-two-status">वाचा</Link>
                ) : (
                  <button className="answer-two-status">वाचा</button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnswerTwo;
